import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class SearchForm extends Component {

	setQuery = (event) => {
		this.props.setQuery (event.target.value);
	};

	search = (event) => {
		event.preventDefault();
		// prevent the search, if there is no input
		if(!this.props.getQuery){
			return false;
		}
		this.props.search();
	};

	render() {
		return (
			<div className="product-search product-search--product-list">
				<form action="/" className="product-search__form" method="GET" role="search">
					<div className="input-group">
						<FormattedMessage id="header.search">
							{(msg)=>( <input className="form-control" name="search" placeholder={msg} type="text" value={this.props.getQuery} onChange={this.setQuery}/> )}
						</FormattedMessage>
						<span className="input-group-btn">
					        <button className="btn btn-default" type="submit" onClick={this.search}>
								<i aria-hidden="true" className="fa fa-search"/>
								<span className="sr-only">Submit</span>
							</button>
					      </span>
					</div>
				</form>
			</div>
		);
	}
}

export default SearchForm;


// WEBPACK FOOTER //
// ./src/components/form/SearchForm.js